import '../Assests/css/components/card.css';

export default function Card({ title, description, techStack, liveLink, githubLink, imageUrl }) {
    return (
        <div className="card">
            {imageUrl && (
                <div className="card-image">
                    <img src={imageUrl} alt={title} />
                </div>
            )}
            <div className="card-content">
                <h3 className="card-title">{title}</h3>
                <p className="card-description">{description}</p>
                
                {techStack && techStack.length > 0 && (
                    <div className="card-tech-stack">
                        {techStack.map((tech, index) => (
                            <span key={index} className="tech-tag">{tech}</span>
                        ))}
                    </div>
                )}
                
                <div className="card-links">
                    {liveLink && (
                        <a href={liveLink} target="_blank" rel="noopener noreferrer" className="card-link">
                            Live Demo
                        </a>
                    )}
                    {githubLink && (
                        <a href={githubLink} target="_blank" rel="noopener noreferrer" className="card-link">
                            GitHub
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}



